import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import compose from '../../../hoc/compose';
import displayNames from '../../displayNames';
import DropDownOption from '../../dropDownOption';
import TooltipOnEllipsis from '../../tooltipOnEllipsis';

var DropDownThemeOption = function DropDownThemeOption(props) {
  return /*#__PURE__*/React.createElement(DropDownOption, _.assign({}, {
    className: 'dropdown-theme-option'
  }, _.omit(props, 'children')), props.isSelectedElement ? /*#__PURE__*/React.createElement("div", {
    className: "dropdown-theme-option-label",
    key: "themeLabel"
  }, props.label) : null, props.isSelectedElement ? null : /*#__PURE__*/React.createElement("div", {
    className: "dropdown-theme-option-preview",
    key: "themePreview"
  }, props.color ? /*#__PURE__*/React.createElement("div", {
    className: "dropdown-theme-option-color",
    key: "dropdownThemeColor",
    style: {
      backgroundColor: props.color
    }
  }) : null, /*#__PURE__*/React.createElement(TooltipOnEllipsis, {
    marginTop: -10,
    closeOnMouseClick: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-theme-option-content",
    style: _.assign({
      fontSize: Math.min(props.size, props.maxFontSize || 30) + 'px'
    }, props.theme)
  }, props.label)), props.htmlTag ? /*#__PURE__*/React.createElement("div", {
    className: "dropdown-theme-option-html-tag",
    key: "dropdownThemeTag"
  }, /*#__PURE__*/React.createElement(props.htmlTag)) : null), props.isSelectedElement ? null : /*#__PURE__*/React.createElement("div", {
    className: "dropdown-theme-option-size",
    key: "themeSize"
  }, props.size + 'px'));
};

DropDownThemeOption.displayName = displayNames.DROP_DOWN_THEME_OPTION;
DropDownThemeOption.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  wasVisible: PropTypes.bool,
  wasVisibleStyle: PropTypes.object,
  size: PropTypes.number.isRequired,
  color: PropTypes.string,
  htmlTag: PropTypes.string,
  theme: PropTypes.object,
  maxFontSize: PropTypes.number,
  selectedValueSuffix: PropTypes.string
};
export default compose(DropDownThemeOption);